(function () {
  if (window.__mimroWishlistInit) return;
  window.__mimroWishlistInit = true;

  var STORAGE_KEY = 'theme:wishlist';

  function readWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* ignore quota / private-mode errors */
    }
  }

  function isInWishlist(items, productId) {
    return items.some(function (item) {
      return String(item.id) === String(productId);
    });
  }

  function syncButtonState(button) {
    var items = readWishlist();
    var productId = button.getAttribute('data-wishlist-product-id');
    var active = isInWishlist(items, productId);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Remove from Wishlist' : 'Add to Wishlist');
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButtonState);
  }

  function toggleWishlist(button) {
    var productId = button.getAttribute('data-wishlist-product-id');
    var handle = button.getAttribute('data-wishlist-handle');
    var items = readWishlist();
    var exists = isInWishlist(items, productId);

    if (exists) {
      items = items.filter(function (item) {
        return String(item.id) !== String(productId);
      });
    } else {
      items.push({ id: productId, handle: handle, addedAt: Date.now() });
    }

    writeWishlist(items);
    syncAllButtons();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist(button);
      return;
    }

    var removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      var productId = removeButton.getAttribute('data-wishlist-remove');
      var items = readWishlist().filter(function (item) {
        return String(item.id) !== String(productId);
      });
      writeWishlist(items);
      syncAllButtons();
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
    }
  });

  document.addEventListener('wishlist:updated', function () {
    var countEls = document.querySelectorAll('[data-wishlist-count]');
    if (countEls.length) {
      var count = readWishlist().length;
      countEls.forEach(function (el) {
        el.textContent = count;
      });
    }
    var root = document.getElementById('wishlist-page-root');
    if (root) renderWishlistPage(root);
  });

  function renderWishlistPage(root) {
    var items = readWishlist();

    if (!items.length) {
      root.innerHTML = '<p class="wishlist-empty">' + (root.getAttribute('data-empty-text') || 'Your wishlist is empty.') + '</p>';
      return;
    }

    root.innerHTML = '<div class="wishlist-grid"></div>';
    var grid = root.querySelector('.wishlist-grid');

    items.forEach(function (item) {
      if (!item.handle) return;
      fetch('/products/' + item.handle + '.js')
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (product) {
          if (!product) return;
          var card = document.createElement('div');
          card.className = 'wishlist-item';
          var image = product.featured_image || (product.images && product.images[0]) || '';
          var price = (product.price / 100).toFixed(2);
          card.innerHTML =
            '<a href="/products/' + product.handle + '" class="wishlist-item__image">' +
              (image ? '<img src="' + image + '" alt="' + (product.featured_image_alt || product.title).replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="wishlist-item__info">' +
              '<a href="/products/' + product.handle + '" class="wishlist-item__title">' + product.title + '</a>' +
              '<div class="wishlist-item__price">$' + price + '</div>' +
              '<button type="button" class="btn btn--secondary wishlist-item__remove" data-wishlist-remove="' + item.id + '">Remove</button>' +
            '</div>';
          grid.appendChild(card);
        })
        .catch(function () {
          /* skip products that no longer exist */
        });
    });
  }

  function init() {
    syncAllButtons();
    var root = document.getElementById('wishlist-page-root');
    if (root) renderWishlistPage(root);
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: readWishlist() } }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
